import * as R from 'ramda';
import { useLocation } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import ModalTitle from '@mui/material/DialogTitle';
// icons-material
import CloseIcon from '@mui/icons-material/Close';
// helpers
import * as U from '../../utilities';
// component modal
import { styles } from './ui';
//////////////////////////////////////////////////

const ModalTitleComponent = ({
  onClose,
  children,
  isLoading,
  closeBtnTop,
  closeBtnPadding,
}) => (
  <ModalTitle
    fontSize={16}
    color='text.primary'
    sx={{
      p: 0,
      pb: 1,
      display: 'flex',
      justifyContent: 'space-between',
      '&.MuiTypography-root': {
        maxWidth: '80%',
        breakWord: 'world-break',
      },
    }}
  >
    {children}
    {
      onClose && (
        <IconButton
          onClick={onClose}
          aria-label='close'
          disabled={isLoading}
          title={U.getTranslation('actions.close', 'Close')}
          sx={{
            right: 8,
            position: 'absolute',
            top: closeBtnTop || 16,
            padding: closeBtnPadding || '8px',
            transition: 'transform 0.3s ease-in-out',
            ':hover': {
              transform: 'rotate(180deg)',
              color: theme => theme.colors.darkGreen,
            },
            color: theme => theme.palette.text.secondary,
          }}
        >
          <CloseIcon sx={{ fontSize: '22px' }} />
        </IconButton>
      )
    }
  </ModalTitle>
);

export const ModalComponent = ({
  component,
  isLoading,
  modalTitle,
  handleClose,
  closeBtnTop,
  opened = false,
  closeBtnPadding,
  wrapperStyles = {},
  additionalStyles = {},
  componentBoxSxStyles = {},
}) => {
  const { pathname } = useLocation();

  let valueToPaste = R.compose(
    R.join('_'),
    R.map(R.toUpper),
    R.split('/'),
    R.trim,
  )(R.tail(pathname));

  if (U.isString(modalTitle)) {
    valueToPaste = R.compose(
      R.join('_'),
      R.map(R.toUpper),
      R.split(' '),
      R.trim,
    )(modalTitle);
  }

  return (
    <Modal
      open={opened}
      sx={wrapperStyles}
      onClose={handleClose}
      aria-labelledby='parent-modal-title'
      aria-describedby='parent-modal-description'
    >
      <Box
        id={`${valueToPaste}_modal`}
        backgroundColor='background.default'
        sx={R.mergeDeepRight(styles, additionalStyles)}
      >
        <ModalTitleComponent
          isLoading={isLoading}
          onClose={handleClose}
          closeBtnTop={closeBtnTop}
          id='customized-dialog-title'
          closeBtnPadding={closeBtnPadding}
        >
          {modalTitle}
        </ModalTitleComponent>
        <Box sx={componentBoxSxStyles}>{component}</Box>
      </Box>
    </Modal>
  );
};
